<template>
  <Form
    :is-show-form-val="isShowForm"
    :is-load-form-val="isLoadForm"
    :r-id-val="id"
    :r-kolok="rKolok"
    :r-kib="rKib"
    :title="title"
    :r-kobar="rKobar"
    :r-nabar="rNabar"
    :r-kode-register-barang="rKodeRegisterBarang"
    :r-nilai-perolehan="rNilaiPerolehan"
    :r-tahun-perolehan="rTahunPerolehan"
    :r-keberadaan="rKeberadaan"
    :r-tanda2batas-tanah-utara="rTanda2BatasTanahUtara"
    :r-tanda2batas-tanah-timur="rTanda2BatasTanahTimur"
    :r-tanda2batas-tanah-selatan="rTanda2BatasTanahSelatan"
    :r-tanda2batas-tanah-barat="rTanda2BatasTanahBarat"
    :r-alasan-tidak-ada="rAlasanTidakAda"
    :r-alasan-tidak-ada-p="rAlasanTidakAdaP"
    :r-keterangan-beton="rKeteranganBeton"
    :r-keterangan-beton-sebutkan="rKeteranganBetonSebutkan"
    :r-peruntukkan-penggunaan-bmd="rPeruntukkanPenggunaanBmd"
    :r-ukuran="rUkuran"
    :r-satuan="rSatuan"
    :r-kesesuaian-ukuran="rKesesuaianUkuran"
    :r-satuan-seharusnya="rSatuanSeharusnya"
    :r-ukuran-seharusnya="rUkuranSeharusnya"
    :r-nama-spesifikasi-barang="rNamaSpesifikasiBarang"
    :r-alamat="rAlamat"
    :r-provinsi="rProvinsi"
    :r-kab-kota="rKabKota"
    :r-kecamatan="rKecamatan"
    :r-kelurahan="rKelurahan"
    :r-kode-pos="rKodePos"
    :r-jalan="rJalan"
    :r-no-alamat="rNoAlamat"
    :r-rt="rRt"
    :r-rw="rRw"
    :r-gedung-bangunan-tanah-milik="rGedungBangunanTanahMilik"
    :r-is-gedung-bangunan-tanah-milik-tercatat="rIsGedungBangunanTanahMilikTercatat"
    :r-gedung-bangunan-tanah-milik-pd-ukpd="rGedungBangunanTanahMilikPdUkpd"
    :r-gedung-bangunan-tanah-milik-kobar="rGedungBangunanTanahMilikKobar"
    :r-gedung-bangunan-tanah-milik-register="rGedungBangunanTanahMilikRegister"
    :r-gedung-bangunan-tanah-milik-keterangan="rGedungBangunanTanahMilikKeterangan"
    :r-gedung-bangunan-tanah-milik-sebutkan="rGedungBangunanTanahMilikSebutkan"
    :r-is-indikasi-ganda="rIsIndikasiGanda"
    :r-indikasi-ganda-dengan="rIndikasiGandaDengan"
    :r-indikasi-ganda-sebutkan="rIndikasiGandaSebutkan"
    :r-indikasi-gabungan="rIndikasiGabungan"
    :r-indikasi-gabungan-keterangan="rIndikasiGabunganKeterangan"
    :r-sk-penggunaan="rSkPenggunaan"
    :r-nomor-sk-penggunaan="rNomorSkPenggunaan"
    :r-tahun-sk-penggunaan="rTahunSkPenggunaan"
    :r-penggunaan="rPenggunaan"
    :r-digunakan-bersama="rDigunakanBersama"
    :r-pd-ukpd="rPdUkpd"
    :r-digunakan-untuk="rDigunakanUntuk"
    :r-pemanfaat="rPemanfaat"
    :r-is-lantai-digunakan="rIsLantaiDigunakan"
    :r-jumlah-seluruh-lantai="rJumlahSeluruhLantai"
    :r-jumlah-lantai-digunakan="rJumlahLantaiDigunakan"
    :r-is-atap-beton="rIsAtapBeton"
    :r-is-atap-beton-is-digunakan="rIsAtapBetonIsDigunakan"
    :r-is-basement="rIsBasement"
    :r-is-basement-is-digunakan="rIsBasementIsDigunakan"
    :r-is-halaman-utama="rIsHalamanUtama"
    :r-is-halaman-utama-is-digunakan="rIsHalamanUtamaIsDigunakan"
    :r-jumlah-lantai-tidak-digunakan="rJumlahLantaiTidakDigunakan"
    :r-atap-beton-digunakan="rAtapBetonDigunakan"
    :r-basement-digunakan="rBasementDigunakan"
    :r-halaman-utama-digunakan="rHalamanUtamaDigunakan"
    :r-is-bertingkat="rIsBertingkat"
    :r-pengamanan-fisik="rPengamananFisik"
    :r-fisik-dikuasai="rFisikDikuasai"
    :r-fisik-dikuasai-sebutkan="rFisikDikuasaiSebutkan"
    :r-fisik-tidak-dikuasai-sebutkan="rFisikTidakDikuasaiSebutkan"
    :jumlah-lantai-digunakan-val="jumlahLantaiDigunakan"
    :keterangan-beton-sebutkan-val="keteranganBetonSebutkan"
    :peruntukkan-penggunaan-bmd-val="peruntukkanPenggunaanBmd"
    :sebab-lain-val="sebabLain"
    :ukuran-seharusnya-val="ukuranSeharusnya"
    :nama-spesifikasi-barang-val="namaSpesifikasiBarang"
    :jumlah-lantai-tidak-digunakan-val="jumlahLantaiTidakDigunakan"
    :nomor-sk-penggunaan-val="nomorSkPenggunaan"
    :tahun-sk-penggunaan-val="tahunSkPenggunaan"
    :digunakan-untuk-val="digunakanUntuk"
    :pemanfaat-val="pemanfaat"
    :gedung-bangunan-tanah-milik-keterangan-val="gedungBangunanTanahMilikKeterangan"
    :gedung-bangunan-tanah-milik-sebutkan-val="gedungBangunanTanahMilikSebutkan"
    :jalan-val="jalan"
    :no-alamat-val="noAlamat"
    :rt-val="rt"
    :rw-val="rw"
    :indikasi-ganda-sebutkan-val="indikasiGandaSebutkan"
    :indikasi-gabungan-keterangan-val="indikasiGabunganKeterangan"
    :atap-beton-digunakan-val="atapBetonDigunakan"
    :basement-digunakan-val="basementDigunakan"
    :halaman-utama-digunakan-val="halamanUtamaDigunakan"
    :fisik-dikuasai-sebutkan-val="fisikDikuasaiSebutkan"
    :tanda2batas-tanah-utara-val="tanda2BatasTanahUtara"
    :tanda2batas-tanah-timur-val="tanda2BatasTanahTimur"
    :tanda2batas-tanah-selatan-val="tanda2BatasTanahSelatan"
    :tanda2batas-tanah-barat-val="tanda2BatasTanahBarat"
  />
</template>

<script>
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import Form from '@/views/koreksi/cleansing/Form.vue'
import UtilsFunction from '@/views/koreksi/UtilsFunction'
import apiCleansing from '@/composables/koreksi/cleansing'

export default {
  setup(props, context) {
    const g = context.root

    const utilsFunction = new UtilsFunction(g)

    const defaultVNull = { text: '-- Pilih Salah Satu --', value: null }
    const title = ref('KIB C - Fase Desktop')

    // form name
    const isLoadForm = ref(false)
    const isShowForm = ref(false)

    // form real
    const rKolok = ref('')
    const rKib = ref('')
    const rKobar = ref('')
    const rNabar = ref('')
    const rKodeRegisterBarang = ref('')
    const rNilaiPerolehan = ref('')
    const rTahunPerolehan = ref('')
    const rTanda2BatasTanahUtara = ref('')
    const rTanda2BatasTanahTimur = ref('')
    const rTanda2BatasTanahSelatan = ref('')
    const rTanda2BatasTanahBarat = ref('')
    const rKeberadaan = ref('')
    const rAlasanTidakAda = ref('')
    const rAlasanTidakAdaP = ref('')
    const rKeteranganBeton = ref('')
    const rKeteranganBetonSebutkan = ref('')
    const rPeruntukkanPenggunaanBmd = ref('')
    const rUkuran = ref('')
    const rSatuan = ref('')
    const rKesesuaianUkuran = ref('')
    const rSatuanSeharusnya = ref('')
    const rUkuranSeharusnya = ref('')
    const rNamaSpesifikasiBarang = ref('')
    const rAlamat = ref('')
    const rProvinsi = ref('')
    const rKabKota = ref('')
    const rKecamatan = ref('')
    const rKelurahan = ref('')
    const rKodePos = ref('')
    const rJalan = ref('')
    const rNoAlamat = ref('')
    const rRt = ref('')
    const rRw = ref('')
    const rGedungBangunanTanahMilik = ref('')
    const rIsGedungBangunanTanahMilikTercatat = ref('')
    const rGedungBangunanTanahMilikPdUkpd = ref(defaultVNull)
    const rGedungBangunanTanahMilikKobar = ref(defaultVNull)
    const rGedungBangunanTanahMilikRegister = ref(defaultVNull)
    const rGedungBangunanTanahMilikKeterangan = ref('')
    const rGedungBangunanTanahMilikSebutkan = ref('')
    const rIsIndikasiGanda = ref('')
    const rIndikasiGandaDengan = ref('')
    const rIndikasiGandaSebutkan = ref('')
    const rIndikasiGabungan = ref('')
    const rIndikasiGabunganKeterangan = ref('')
    const rSkPenggunaan = ref('')
    const rNomorSkPenggunaan = ref('')
    const rTahunSkPenggunaan = ref('')
    const rPenggunaan = ref('')
    const rDigunakanUntuk = ref([])
    const rPemanfaat = ref([
      {
        value: null,
        namaPemanfaat: '',
        dasarPenggunaan: '',
        dasarPenggunaanTipe: '',
      },
    ])
    const rPdUkpd = ref([])
    const rDigunakanBersama = ref([])
    const rIsLantaiDigunakan = ref('')
    const rJumlahLantaiDigunakan = ref('')
    const rJumlahSeluruhLantai = ref('')
    const rIsAtapBeton = ref('')
    const rIsAtapBetonIsDigunakan = ref('')
    const rIsBasement = ref('')
    const rIsBasementIsDigunakan = ref('')
    const rIsHalamanUtama = ref('')
    const rIsHalamanUtamaIsDigunakan = ref('')
    const rJumlahLantaiTidakDigunakan = ref('')
    const rAtapBetonDigunakan = ref('')
    const rBasementDigunakan = ref('')
    const rHalamanUtamaDigunakan = ref('')
    const rIsBertingkat = ref('')
    const rPengamananFisik = ref('')
    const rFisikDikuasai = ref('')
    const rFisikDikuasaiSebutkan = ref('')
    const rFisikTidakDikuasaiSebutkan = ref('')

    const jumlahLantaiDigunakan = ref('')
    const keteranganBetonSebutkan = ref(null)
    const peruntukkanPenggunaanBmd = ref(null)
    const sebabLain = ref(null)
    const ukuranSeharusnya = ref('')
    const namaSpesifikasiBarang = ref('')
    const jumlahLantaiTidakDigunakan = ref('')
    const nomorSkPenggunaan = ref('')
    const tahunSkPenggunaan = ref('')
    const digunakanUntuk = ref([])
    const pemanfaat = ref([
      {
        value: null,
        namaPemanfaat: '',
        dasarPenggunaan: '',
        dasarPenggunaanTipe: '',
      },
    ])
    const gedungBangunanTanahMilikKeterangan = ref('')
    const gedungBangunanTanahMilikSebutkan = ref('')
    const jalan = ref('')
    const noAlamat = ref('')
    const rt = ref('')
    const rw = ref('')
    const indikasiGandaSebutkan = ref('')
    const indikasiGabunganKeterangan = ref(null)
    const atapBetonDigunakan = ref('')
    const basementDigunakan = ref('')
    const halamanUtamaDigunakan = ref('')
    const fisikDikuasaiSebutkan = ref('')
    const tanda2BatasTanahUtara = ref('')
    const tanda2BatasTanahTimur = ref('')
    const tanda2BatasTanahSelatan = ref('')
    const tanda2BatasTanahBarat = ref('')

    ///
    const dataKib = ref([])
    const dataPdUkpd = ref([])
    const dataGedungBangunanTanahMilikRegister = ref([defaultVNull])
    const dataGedungBangunanTanahMilikKobar = ref([defaultVNull])
    const dataProvinsi = ref([defaultVNull])
    const dataKabKota = ref([defaultVNull])
    const dataKecamatan = ref([defaultVNull])
    const dataKelurahan = ref([defaultVNull])
    const dataKobar = ref([])

    const isShowInfo = ref(false)

    const getDataById = async () => {
      const response = await apiCleansing.getDataById(g, props.id)
      const { data, code } = response
      if (code == 200) {
        const {
          di_m_lantai_tdk_use: diMLantaiTdkUse,
          dk_ket_beton_note: dkKetBetonNote,
          dk_peruntukan_bmd: dkPeruntukanBmd,
          alasan_tidak_ada_note: alasanTidakAdaNote,
          di_m_ukuran_a: diMUkuranA,
          di_nm_spesifikasi_barang: diNmSpesifikasiBarang,
          di_m_lantai_tdk_not: diMLantaiTdkNot,
          di_sk_penggunaan_no: diSkPenggunaanNo,
          di_sk_penggunaan_tahun: diSkPenggunaanTahun,
          di_penggunaan_untuk: diPenggunaanUntuk,
          di_penggunaan_pemanfaat_nama: diPenggunaanPemanfaatNama,
          di_gedung_bangunan_diatas_tanah_milik_sebut: diGedungBangunanDiatasTanahMilikSebut,
          di_jalan: diJalan,
          di_no_jalan: diNoJalan,
          di_rt: diRt,
          di_rw: diRw,
          di_indikasi_ganda_sebutkan: diIndikasiGandaSebutkan,
          di_indikasi_gabungan_keterangan: diIndikasiGabunganKeterangan,
          di_pp_at_ada_digunakan_oleh: diPpAtAdaDigunakanOleh,
          di_pp_bm_ada_digunakan_oleh: diPpBmAdaDigunakanOleh,
          di_pp_ht_ada_digunakan_oleh: diPpHtAdaDigunakanOleh,
          di_pengamanan_fisik_note: diPengamananFisikNote,
          tbt_utara: tbtUtara,
          tbt_timur: tbtTimur,
          tbt_selatan: tbtSelatan,
          tbt_barat: tbtBarat,
        } = data
        jumlahLantaiDigunakan.value = diMLantaiTdkUse
        keteranganBetonSebutkan.value = dkKetBetonNote
        peruntukkanPenggunaanBmd.value = dkPeruntukanBmd
        sebabLain.value = alasanTidakAdaNote
        ukuranSeharusnya.value = diMUkuranA
        namaSpesifikasiBarang.value = diNmSpesifikasiBarang || ''
        jumlahLantaiTidakDigunakan.value = diMLantaiTdkNot
        nomorSkPenggunaan.value = diSkPenggunaanNo
        tahunSkPenggunaan.value = diSkPenggunaanTahun
        digunakanUntuk.value = Array.isArray(diPenggunaanUntuk) ? diPenggunaanUntuk.map(item => ({ value: item })) : rDigunakanUntuk.value.map(() => ({
          value: null,
        }))
        pemanfaat.value = Array.isArray(diPenggunaanPemanfaatNama) ? diPenggunaanPemanfaatNama.map(item => ({ namaPemanfaat: item })) : rPemanfaat.value.map(() => ({
          namaPemanfaat: '',
        }))
        gedungBangunanTanahMilikKeterangan.value = diGedungBangunanDiatasTanahMilikSebut
        gedungBangunanTanahMilikSebutkan.value = diGedungBangunanDiatasTanahMilikSebut
        jalan.value = diJalan
        noAlamat.value = diNoJalan
        rt.value = diRt
        rw.value = diRw
        indikasiGandaSebutkan.value = diIndikasiGandaSebutkan
        indikasiGabunganKeterangan.value = diIndikasiGabunganKeterangan
        atapBetonDigunakan.value = diPpAtAdaDigunakanOleh
        basementDigunakan.value = diPpBmAdaDigunakanOleh
        halamanUtamaDigunakan.value = diPpHtAdaDigunakanOleh
        fisikDikuasaiSebutkan.value = diPengamananFisikNote
        tanda2BatasTanahUtara.value = tbtUtara
        tanda2BatasTanahTimur.value = tbtTimur
        tanda2BatasTanahSelatan.value = tbtSelatan
        tanda2BatasTanahBarat.value = tbtBarat
      }
    }

    const getData = async () => {
      isShowForm.value = true
      isLoadForm.value = true
      const result = await utilsFunction.getBmdById(props.id)
      rKolok.value = result.kolok
      rKib.value = result.kib
      title.value = result.title
      rKobar.value = result.kobar
      rNabar.value = result.nabar
      rKodeRegisterBarang.value = result.kodeRegisterBarang
      rNilaiPerolehan.value = result.nilaiPerolehan
      rTahunPerolehan.value = result.tahunPerolehan
      rKeberadaan.value = result.keberadaan
      rTanda2BatasTanahUtara.value = result.tanda2BatasTanahUtara
      rTanda2BatasTanahTimur.value = result.tanda2BatasTanahTimur
      rTanda2BatasTanahSelatan.value = result.tanda2BatasTanahSelatan
      rTanda2BatasTanahBarat.value = result.tanda2BatasTanahBarat
      rAlasanTidakAda.value = result.alasanTidakAda
      rAlasanTidakAdaP.value = result.alasanTidakAdaP
      rKeteranganBeton.value = result.keteranganBeton
      rKeteranganBetonSebutkan.value = result.keteranganBetonSebutkan
      rPeruntukkanPenggunaanBmd.value = result.peruntukkanPenggunaanBmd
      rUkuran.value = result.ukuran
      rSatuan.value = result.satuan
      rKesesuaianUkuran.value = result.kesesuaianUkuran
      rSatuanSeharusnya.value = result.satuanSeharusnya
      rUkuranSeharusnya.value = result.ukuranSeharusnya
      rNamaSpesifikasiBarang.value = result.namaSpesifikasiBarang
      rAlamat.value = result.alamat
      rProvinsi.value = result.provinsi
      rKabKota.value = result.kabKota
      rKecamatan.value = result.kecamatan
      rKelurahan.value = result.kelurahan
      rKodePos.value = result.kodePos
      rJalan.value = result.jalan
      rNoAlamat.value = result.noAlamat
      rRt.value = result.rt
      rRw.value = result.rw
      rGedungBangunanTanahMilik.value = result.gedungBangunanTanahMilik
      rIsGedungBangunanTanahMilikTercatat.value = result.isGedungBangunanTanahMilikTercatat
      rGedungBangunanTanahMilikPdUkpd.value = result.gedungBangunanTanahMilikPdUkpd
      rGedungBangunanTanahMilikKobar.value = result.gedungBangunanTanahMilikKobar
      rGedungBangunanTanahMilikRegister.value = result.gedungBangunanTanahMilikRegister
      rGedungBangunanTanahMilikKeterangan.value = result.gedungBangunanTanahMilikKeterangan
      rGedungBangunanTanahMilikSebutkan.value = result.gedungBangunanTanahMilikSebutkan
      rIsIndikasiGanda.value = result.isIndikasiGanda
      rIndikasiGandaDengan.value = result.indikasiGandaDengan
      rIndikasiGandaSebutkan.value = result.indikasiGandaSebutkan
      rIndikasiGabungan.value = result.indikasiGabungan
      rIndikasiGabunganKeterangan.value = result.indikasiGabunganKeterangan
      rSkPenggunaan.value = result.skPenggunaan
      rNomorSkPenggunaan.value = result.nomorSkPenggunaan
      rTahunSkPenggunaan.value = result.tahunSkPenggunaan
      rPenggunaan.value = result.penggunaan
      rDigunakanBersama.value = result.digunakanBersama
      rPdUkpd.value = result.pdUkpd
      rDigunakanUntuk.value = result.digunakanUntuk
      digunakanUntuk.value = result.digunakanUntuk.map(() => ({
        value: null,
      }))
      rPemanfaat.value = result.pemanfaat
      rIsLantaiDigunakan.value = result.isLantaiDigunakan
      rJumlahSeluruhLantai.value = result.jumlahSeluruhLantai
      rJumlahLantaiDigunakan.value = result.jumlahLantaiDigunakan
      rIsAtapBeton.value = result.isAtapBeton
      rIsAtapBetonIsDigunakan.value = result.isAtapBetonIsDigunakan
      rIsBasement.value = result.isBasement
      rIsBasementIsDigunakan.value = result.isBasementIsDigunakan
      rIsHalamanUtama.value = result.isHalamanUtama
      rIsHalamanUtamaIsDigunakan.value = result.isHalamanUtamaIsDigunakan
      rJumlahLantaiTidakDigunakan.value = result.jumlahLantaiTidakDigunakan
      rAtapBetonDigunakan.value = result.atapBetonDigunakan
      rBasementDigunakan.value = result.basementDigunakan
      rHalamanUtamaDigunakan.value = result.halamanUtamaDigunakan
      rIsBertingkat.value = result.isBertingkat
      rPengamananFisik.value = result.pengamananFisik
      rFisikDikuasai.value = result.fisikDikuasai
      rFisikDikuasaiSebutkan.value = result.fisikDikuasaiSebutkan
      rFisikTidakDikuasaiSebutkan.value = result.fisikTidakDikuasaiSebutkan
      getDataById()
      isLoadForm.value = false
    }

    getData()

    return {
      title,
      isShowInfo,
      // form submit
      isLoadForm,
      isShowForm,
      rKolok,
      rKib,
      rKobar,
      rNabar,
      rKodeRegisterBarang,
      rNilaiPerolehan,
      rTahunPerolehan,
      rTanda2BatasTanahUtara,
      rTanda2BatasTanahTimur,
      rTanda2BatasTanahSelatan,
      rTanda2BatasTanahBarat,
      rKeberadaan,
      rAlasanTidakAda,
      rAlasanTidakAdaP,
      rKeteranganBeton,
      rKeteranganBetonSebutkan,
      rPeruntukkanPenggunaanBmd,
      rUkuran,
      rSatuan,
      rKesesuaianUkuran,
      rSatuanSeharusnya,
      rUkuranSeharusnya,
      rNamaSpesifikasiBarang,
      rAlamat,
      rProvinsi,
      rKabKota,
      rKecamatan,
      rKelurahan,
      rKodePos,
      rJalan,
      rNoAlamat,
      rRt,
      rRw,
      rGedungBangunanTanahMilik,
      rIsGedungBangunanTanahMilikTercatat,
      rGedungBangunanTanahMilikPdUkpd,
      rGedungBangunanTanahMilikKobar,
      rGedungBangunanTanahMilikRegister,
      rGedungBangunanTanahMilikKeterangan,
      rGedungBangunanTanahMilikSebutkan,
      rIsIndikasiGanda,
      rIndikasiGandaDengan,
      rIndikasiGandaSebutkan,
      rIndikasiGabungan,
      rIndikasiGabunganKeterangan,
      rSkPenggunaan,
      rNomorSkPenggunaan,
      rTahunSkPenggunaan,
      rPenggunaan,
      rDigunakanUntuk,
      rPemanfaat,
      rPdUkpd,
      rDigunakanBersama,
      rIsLantaiDigunakan,
      rJumlahSeluruhLantai,
      rJumlahLantaiDigunakan,
      rIsAtapBeton,
      rIsAtapBetonIsDigunakan,
      rIsBasement,
      rIsBasementIsDigunakan,
      rIsHalamanUtama,
      rIsHalamanUtamaIsDigunakan,
      rJumlahLantaiTidakDigunakan,
      rAtapBetonDigunakan,
      rBasementDigunakan,
      rHalamanUtamaDigunakan,
      rIsBertingkat,
      rPengamananFisik,
      rFisikDikuasai,
      rFisikDikuasaiSebutkan,
      rFisikTidakDikuasaiSebutkan,
      jumlahLantaiDigunakan,
      keteranganBetonSebutkan,
      peruntukkanPenggunaanBmd,
      sebabLain,
      ukuranSeharusnya,
      namaSpesifikasiBarang,
      jumlahLantaiTidakDigunakan,
      nomorSkPenggunaan,
      tahunSkPenggunaan,
      digunakanUntuk,
      pemanfaat,
      gedungBangunanTanahMilikKeterangan,
      gedungBangunanTanahMilikSebutkan,
      jalan,
      noAlamat,
      rt,
      rw,
      indikasiGandaSebutkan,
      indikasiGabunganKeterangan,
      atapBetonDigunakan,
      basementDigunakan,
      halamanUtamaDigunakan,
      fisikDikuasaiSebutkan,
      tanda2BatasTanahUtara,
      tanda2BatasTanahTimur,
      tanda2BatasTanahSelatan,
      tanda2BatasTanahBarat,
      dataKib,
      dataPdUkpd,
      dataGedungBangunanTanahMilikRegister,
      dataProvinsi,
      dataKabKota,
      dataKecamatan,
      dataKelurahan,
      dataGedungBangunanTanahMilikKobar,
      dataKobar,
    }
  },
  directives: {
    Ripple,
  },
  components: {
    Form,
  },
  props: {
    id: { type: String, default: '' },
  },
  data() {
    return {
      dataPemanfaat: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '1', text: 'Pemerintah Pusat' },
        { value: '2', text: 'Pemerintah Daerah Lainnya' },
        { value: '3', text: 'Pihak Lain Selain Pemerintah' },
      ],
      ruleAngka: {
        numeral: true,
        numeralDecimalMark: ',',
        delimiter: '.',
      },
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
